import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-039ec08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex-grow-1 d-flex flex-row" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-caret-right" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "flex-shrink-0"
}
const _hoisted_10 = { class: "dropdown-submenu" }
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.show)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dropdown-outside dropdown-menu",
        style: _normalizeStyle({ left: `${_ctx.calculatedPosition.left}px !important`, top: `${_ctx.calculatedPosition.top}px !important` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.isHeader(item))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 'h' + index,
                  class: "header d-flex justify-content-between"
                }, [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1)
                ]))
              : (!_ctx.isHidden(item) && _ctx.permitted[index])
                ? (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (_ctx.click(item, $event)),
                    key: 'i' + index,
                    class: _normalizeClass(["dropdown-item d-flex justify-content-between", { disabled: _ctx.isDisabled(item) }])
                  }, [
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["item-icon fa fa-fw mr-2", _ctx.getIcon(item)])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getTitle(item)), 1),
                      (item.route)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "item-icon-external fa fa-fw fa-external-link-alt",
                            onClick: _withModifiers(($event: any) => (_ctx.click(item, $event, true)), ["stop"])
                          }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true)
                    ]),
                    (item.children.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                      : _createCommentVNode("", true),
                    (item.children.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("ul", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (!_ctx.isHidden(child) && _ctx.permitted[index])
                                    ? (_openBlock(), _createElementBlock("li", {
                                        key: childIndex,
                                        class: _normalizeClass(["dropdown-item", { disabled: _ctx.isDisabled(child) }]),
                                        onClick: _withModifiers(($event: any) => (_ctx.click(child, $event)), ["stop"])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["item-icon fa-fw mr-1", _ctx.getIcon(child)])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getTitle(child)), 1)
                                      ], 10, _hoisted_12))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_2))
                : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ], 4)), [
        [_directive_click_outside, 
            () => {
                _ctx.show = false;
            }
        ]
      ])
    : _createCommentVNode("", true)
}